import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async basico(params) {
    const r = await api.get(API_URL + "bot/basico", { params });
    return r.data;
  },

  async premium() {
    const r = await api.get(API_URL + "bot/premium");
    return r.data;
  },

  async log(params) {
    const r = await api.get(API_URL + "bot/log", { params });
    return r.data;
  },
};
